import { useAppContext } from '@datapad/data-model';
function isCharacterVisible(character, appContext) {
    const effectivePermissionLevel = appContext.getEffectivePermissionLevel();
    if (effectivePermissionLevel === 'game-master') {
        return true;
    }
    if (character.famous) {
        return true;
    }
    if (effectivePermissionLevel === 'guest') {
        return false;
    }
    if (!('character' in appContext) || appContext.character === undefined) {
        return false;
    }
    const sessionCharacter = appContext.getCharacter(appContext.character);
    if (character.id === sessionCharacter.id) {
        return false;
    }
    for (const knownByCharacter of character.knownBy) {
        if (knownByCharacter.id === sessionCharacter.id) {
            return true;
        }
    }
    return false;
}
export function useVisibleContacts() {
    const appContext = useAppContext();
    const allCharacters = appContext.getAllCharacters();
    return allCharacters.filter((character) => isCharacterVisible(character, appContext));
}
//# sourceMappingURL=useVisibleContacts.js.map